module.exports = __webpack_public_path__ + "img/logo.434ee759.png";